import { MILLION_USERS } from '../../constants/constants';

import appPreviewImageDepthMaps from './assets/screenViews/depth_map_app.png';
import appPreviewImageCatchLocations from './assets/screenViews/catch_locations_app.png';
import appPreviewTopBaits from './assets/screenViews/top_baits_app.png';
import appPreviewRegulations from './assets/screenViews/regulations_app.png';
import defaultHeaderImgDesktop from './assets/screenViews/phone_preview_header_desktop@2x.png';
import appPreviewImageWaypoints from './assets/screenViews/waypoints_app.png';
import sectionImageWaypointsMobile from './assets/sectionBackgrounds/waypoints_mobile.jpg';
import sectionImageWaypointsTablet from './assets/sectionBackgrounds/waypoints_tablet.jpg';
import sectionImageWaypointsDesktop from './assets/sectionBackgrounds/waypoints_desktop.jpg';
import sectionImageDeepWaterMobile from './assets/sectionBackgrounds/depth_map_mobile.jpg';
import sectionImageDeepWaterTablet from './assets/sectionBackgrounds/depth_map_tablet.jpg';
import sectionImageDeepWaterDesktop from './assets/sectionBackgrounds/depth_map_desktop.jpg';
import sectionImageRegulationsMobile from './assets/sectionBackgrounds/regulations_mobile.jpg';
import sectionImageRegulationsTablet from './assets/sectionBackgrounds/regulations_tablet.jpg';
import sectionImageRegulationsDesktop from './assets/sectionBackgrounds/regulations_desktop.jpg';
import sectionImageCatchPostionsMobile from './assets/sectionBackgrounds/fish_in_hand_mobile_3.jpg';
import sectionImageCatchPostionsTablet from './assets/sectionBackgrounds/fish_in_hand_tablet_3.jpg';
import sectionImageCatchPostionsDesktop from './assets/sectionBackgrounds/fish_in_hand_desktop_3.jpg';
import sectionImageTopBaitsMobile from './assets/sectionBackgrounds/top_baits_mobile.jpg';
import sectionImageTopBaitsTablet from './assets/sectionBackgrounds/top_baits_tablet.jpg';
import sectionImageTopBaitsDesktop from './assets/sectionBackgrounds/top_baits_desktop.jpg';
import { ProSectionProps } from './components/ProSection';

export const DEFAULT_HEADER_DATA = {
  headlineTop: '3 months of Fishbrain Pro',
  headline: 'Only for fishing license holders',
  headerImg: defaultHeaderImgDesktop,
};

export const DEFAULT_PRO_FEATURES_LIST: { key: number; text: string }[] = [
  { key: 1, text: 'Exact catch locations' },
  { key: 2, text: 'Bait and lure recommendations' },
  { key: 3, text: 'Navionics depth maps ' },
  { key: 4, text: 'Local regulations' },
  { key: 5, text: 'Private waypoints' },
];

export const DEFAULT_PRO_SECTIONS: ProSectionProps[] = [
  {
    title: 'Exact catch locations',
    description: `Find out exactly where anglers are catching fish and plan your days on the water based on ${MILLION_USERS} million verified public catch locations. Discover locations nearby based on species you’re looking to target.`,
    sectionImageMobile: sectionImageCatchPostionsMobile,
    sectionImageTablet: sectionImageCatchPostionsTablet,
    sectionImageDesktop: sectionImageCatchPostionsDesktop,
    sectionImageAlt: 'Man fishing',
    phoneRight: true,
    appPreviewImage: appPreviewImageCatchLocations,
    appPreviewImageAlt: 'Exact catch locations - App feature preview',
    appOnlyPill: false,
  },
  {
    title: 'Bait and lure recommendations',
    description: `Find the top baits for your target species and area. Make sure your tackle box is stocked with essentials based on data from ${MILLION_USERS} million catches.`,
    sectionImageMobile: sectionImageTopBaitsMobile,
    sectionImageTablet: sectionImageTopBaitsTablet,
    sectionImageDesktop: sectionImageTopBaitsDesktop,
    sectionImageAlt: 'Fishing rod',
    appPreviewImage: appPreviewTopBaits,
    appPreviewImageAlt: 'Baits recommendation - App feature preview',
    appOnlyPill: true,
  },
  {
    title: 'Navionics® depth maps',
    description:
      'Unlock a detailed view of underwater fish-holding structures like humps and holes, drop-offs and ditches. Garmin-owned Navionics® provides HD depth contour maps for US and Canada, so you can outsmart the fish.',
    sectionImageMobile: sectionImageDeepWaterMobile,
    sectionImageTablet: sectionImageDeepWaterTablet,
    sectionImageDesktop: sectionImageDeepWaterDesktop,
    sectionImageAlt: 'Deep water',
    phoneRight: true,
    appPreviewImage: appPreviewImageDepthMaps,
    appPreviewImageAlt: 'Navionics depth maps - App feature preview',
    appOnlyPill: true,
  },
  {
    title: 'Local regulations',
    description:
      'Be sure you can legally fish in a certain area, and know how to comply with all the local regulations to fish in a sustainable way and never get a ticket. Fishbrain regulations provide accurate and up-to-date knowledge about open seasons, bag limits, measurement rules, and more.',
    sectionImageMobile: sectionImageRegulationsMobile,
    sectionImageTablet: sectionImageRegulationsTablet,
    sectionImageDesktop: sectionImageRegulationsDesktop,
    sectionImageAlt: 'Fish in hand',
    appPreviewImage: appPreviewRegulations,
    appPreviewImageAlt: 'Fishing spot prediction - App feature preview',
    appOnlyPill: false,
  },
  {
    title: 'Private waypoints',
    description:
      'Create your own fishing map and add the information you want to remember: the weed bed bustling with fish, that spot where that 20 inch trout broke you off, or a creek you want to check out later. Waypoints are only visible to you, unless you choose to share a specific one with a fishing buddy.',
    sectionImageMobile: sectionImageWaypointsMobile,
    sectionImageTablet: sectionImageWaypointsTablet,
    sectionImageDesktop: sectionImageWaypointsDesktop,
    sectionImageAlt: 'Boat on sea',
    phoneRight: true,
    appPreviewImage: appPreviewImageWaypoints,
    appPreviewImageAlt: 'Private waypoints - App feature preview',
    appOnlyPill: true,
  },
];
